import styled from 'styled-components';

import { style } from './Field';

export default styled.input`
	${style}

	width: 100%;
`;
